import {forwardRef, useState} from "react";
import {FormControl, FormLabel, Box, Flex, Input, InputRightElement, Heading, InputGroup} from "@chakra-ui/react";
import {ReactComponent as Sort} from "../../../assets/icons/asc_desc.svg";

const InputLabel = forwardRef((props, ref) => {
    const {
        label,
        defaultValue = "",
        name,
        value,
        leftAddon,
        isInvalid,
        disabled,
        border = '2px solid',
        rightAddon,
        onChange,
        pattern,
        maxW,
        errormessage,
        inputHeight,
        bg = 'gray.900',
        type,
        ...rest
    } = props;

    const [isFocused, setIsFocused] = useState(!!defaultValue || !!value);

    const handleFocus = () => setIsFocused(true);
    const handleBlur = (e) => {
        if (!e.target.value) setIsFocused(false);
    };

    return (
        <FormControl
            position="relative"
            maxW={maxW}
            variant="floating"
            zIndex="10"
            border={border}
            borderColor={isFocused && !isInvalid ? "purple.500" : isInvalid ? "error.200" : "gray.700"}
            borderRadius="12px"
            transition="border-color 0.2s ease-in-out"
            bg={bg}
        >
            {
                isFocused && label && <FormLabel
                    fontWeight="600"
                    fontSize={{base: "body.xs", lg: "18px"}}
                    position="absolute"
                    left="16px"
                    top={isFocused ? "-3px" : "50%"}
                    px="12px"
                    bg="transparent"
                    transform={isFocused ? "scale(0.9) translateY(-50%)" : "translateY(-50%)"}
                    transition="all 0.2s ease-in-out"
                    _after={{
                        content: '""',
                        position: "absolute",
                        left: "-1px",
                        right: "-1px",
                        top: "47%",
                        height: "15px",
                        backgroundColor: "gray.900",
                        zIndex: "-1",
                    }}
                    color={"gray.400"}
                    pointerEvents="none"
                    zIndex="2"
                >
                    {label}
                </FormLabel>
            }

            <Flex alignItems="center" position="relative">
                {leftAddon && (
                    <Box zIndex="10" left="16px" position="absolute" as="span">
                        {leftAddon}
                    </Box>
                )}
                {rightAddon && (
                    <Box zIndex="11" cursor="pointer" right="16px" position="absolute" as="span">
                        {rightAddon}
                    </Box>
                )}
                <InputGroup>
                    <Input
                        height={inputHeight ?? "56px"}
                        variant="unstyled"
                        fontSize="18px"
                        type={type}
                        defaultValue={defaultValue}
                        onChange={onChange}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        isInvalid={isInvalid}
                        value={value}
                        pattern={pattern}
                        isDisabled={disabled}
                        name={name}
                        ref={ref}
                        placeholder=" "
                        pl={leftAddon ? "44px" : "16px"}
                        pr="44px" // Make space for the icon
                        color="white"
                        {...rest}
                    />
                    {type === 'number' && (
                        <InputRightElement
                            pointerEvents="none"
                            children={<Sort width="14px" height="14px" fill="white"/>} // customize arrow here
                        />
                    )}


                </InputGroup>

            </Flex>
            {isInvalid && (
                <Heading position="absolute" bottom={{base: '-17px', lg: "-20px"}} left="0" color="error.200"
                         fontSize={{base: 'heading.xs', lg: 'heading.sm'}}>
                    {errormessage}
                </Heading>
            )}
        </FormControl>
    );
});

export default InputLabel;
